import React from 'react'
import { Col, Layout, Row } from 'antd'
import { Outlet } from 'react-router-dom'
import MainHeader from './components/MainHeader'
import { SettingsSider } from './components/SettingsSider'

const { Content } = Layout

export const SettingsLayout: React.FC = () => {
  return (
    <Layout>
      <MainHeader />
      <Layout style={{ minHeight: 'calc(100vh - 64px)', marginTop: 64 }}>
        <SettingsSider />
        <Layout style={{ marginLeft: 300 }}>
          <Content>
            <Row className="container-row">
              <Col xs={24} className="px-4">
                <Outlet />
              </Col>
            </Row>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  )
}
